<template>
  <div class="BlackList bc-white pt7 text-left" v-title data-title="黑名单">
    <div class="text-center pb7">
      <van-button v-if="isAdmin" @click="back" size="small" type="info" plain style="">返 回</van-button>
      <van-button v-if="isAdmin" @click="addBlack" size="small" type="info" style="margin-left: 10px;">添加黑名单</van-button>
      <van-button @click="queryBlack" size="small" type="info" style="margin-left: 10px;">查询黑名单信息</van-button>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div v-for="(rc) in records" :key="rc.id"
        @click="goDetail(rc)"
        class="row align-items-center records-item records-line"
      >
        <div class="flex-1">
          <div v-for="(h) in heads" :key="h.field" class="pt3 row align-items-baseline">
            <span class="record-label fs4 fc-less">{{h.title}}：</span>
            <span class="flex-1">
              <!-- <template v-if="h.type==='list'">
                <div v-for="lst in rc[h.field]" :key="lst" class="pr2">
                  {{lst}}
                </div>
              </template> -->
              <div v-if="h.type==='list'" class="row align-items-center">
                <div v-for="(lst, lindex) in rc[h.field]" :key="lst" class="">
                  <!-- <div class="record-list"> -->
                    {{lst}}{{lindex===rc[h.field].length-1?'':'、'}}
                  <!-- </div> -->
                </div>
              </div>
              <template v-else>{{rc[h.field]}}</template>
            </span>
          </div>
          <div class="pt3 row align-items-baseline">
            <span class="record-label fs4 fc-less">状态：</span>
            <div v-if="rc.auditResult === 'approve'" class="fc-success">
              已通过
            </div>
            <div v-else-if="rc.auditResult === 'reject'" class="fc-danger">
              已拒绝
            </div>
            <div v-else class="fc-primary">
              待审核
            </div>
          </div>

        </div>
        <template v-if="isAdmin">
          <div class="row vertical item-action">
            <van-button type="info" size="small">
              编辑
            </van-button>
            <van-button v-if="rc.auditResult !== 'approve'" type="primary" size="small" @click.stop="audit(rc, 'approve')">
              通过
            </van-button>
            <van-button v-if="rc.auditResult !== 'reject'" type="danger" size="small" @click.stop="audit(rc, 'reject')">
              拒绝
            </van-button>
          </div>
        </template>
        <!-- <van-icon v-if="rc.auditResult === 'approve'" name="success" color="#07C160" title="审核通过"/>
        <van-icon v-else-if="rc.auditResult === 'reject'" name="cross" color="#b71831" title="已拒绝"/>
        <van-icon v-else name="question-o" color="#ff976a" title="待审核"/> -->
        <!-- <div v-else class="fc-light">待审核</div> -->
        <div class="pr7"></div>
        <van-icon class="fc-less" name="arrow" />
      </div>
    </van-list>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getBlackList, approveBlack, rejectBlack,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'BlackList',
  components: {},
  data() {
    return {
      loading: false,
      isAdmin: storage.local.get('type') === 1, // 1 管理员 2 报价商 3 测试 4 生产的测试用户
      error: false,
      finished: false,
      size: 20,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],
      params: {},
      heads: [
        { title: '姓名', field: 'name', class: 'col-12' },
        {
          title: '电话', field: 'phoneNumber', class: 'col-12',
        },
        {
          title: '微信号', field: 'wxNumber', class: 'col-24',
        },
      ],
      totalCount: 0,
    };
  },
  methods: {
    audit(item, status) {
      const method = status === 'approve' ? approveBlack : rejectBlack;
      sendRequest(method, { id: item.id }).then(() => {
        this.getBlackList(1);
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getBlackList(this.current + 1);
    },
    getBlackList(page = 1) {
      // console.log(this.loading);
      this.loading = true;
      sendRequest(getBlackList, {
        current: page,
        size: this.size,
        keywords: '',
      }).then((res) => {
        // console.log(res);
        const {
          total = 1, records = [], pages = 1,
        } = res;
        if (page === 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.current = page;
        if ((records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.error = false;
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    goDetail(item = {}) {
      storage.session.set('BLACK_ITEM', item);
      if (this.isAdmin) {
        this.$router.push(`/black/list/edit/${item.id || ''}`);
        return;
      }
      this.$router.push(`/black/list/detail/${item.id || ''}`);
    },
    addBlack() {
      storage.session.set('BLACK_ITEM', {});
      this.$router.push('/black/list/edit');
    },
    queryBlack() {
      storage.session.set('BLACK_ITEM', {});
      this.$router.push('/black/list/query');
    },
    back() {
      if (this.isAdmin) {
        this.$router.push('/home');
      } else {
        this.$router.push('/quotation/home');
      }
    },
    initParams() {
      const { query = {} } = this.$route;
      this.params = Object.assign({}, this.params, {
        name: query.xm,
        idCode: query.hm,
        address: query.dz,
        dk: query.dk,
        zz: query.zz,
        phoneNumber: query.phone,
        wxNumber: query.wx,
      });
    },
  },
  created() {
    // this.getBlackList();
  },
});
</script>
<style scoped>
  .BlackList {
    min-height: 100vh;
    padding-left: 5px;
    padding-right: 5px;
  }
  .required-box {
    width: 90px;
  }
  .BlackList .records-item {
    background-color: #ffffff;
    /* margin-top: 10px; */
    padding: 2px 0 10px 0;
    border-top: 1px solid #c7c1c1;
    /* margin-top: 10px; */
    /* border-radius: 6px; */
  }
  .records-line {
    /* border-top: 1px solid #b7afaf; */
  }
  .record-label {
    width: 80px;
    padding-left: 10px;
  }
  .record-list {
    /* border-radius: 6px; */
    padding: 2px 4px;
    border: 1px solid #1989fa;
  }
  .item-action >>> .van-button {
    margin-left: 0;
    margin-top: 5px;
  }
</style>
